<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <b-col style="padding-left: 0px;">
      <h1>{{ $t('privatePage.normgroup_edit_header') }}</h1>
    </b-col>
    <div v-if="busyFetching" class="text-center">
      <i class="fa fa-4x fa-spinner fa-pulse"></i>
    </div>
    <div v-else>
    <b-col lg="4" style="margin-bottom: 1rem; padding-left: 0px;">
      <span class="fieldHeader">{{$t('name')}}:</span>
      <b-form-input v-model="normGroup.name" />
    </b-col>
    <b-col v-if="!busyFetching" lg="10" style="padding-left: 0px;">
      <EasyDataTable
        :headers="fields"
        :items="itemsModified"
        :alternating="true"
        :rows-per-page="10000"
        :hide-rows-per-page="true"
      >
        <template #expand="item">
          <b-card class="mt-2 mb-2">
            <b-row>
              <b-col class="col-auto">
                <div class="normSum">
                  1
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone2" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  2
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone3" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  3
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone4" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  4
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone5" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  5
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone6" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  6
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone7" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  7
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone8" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  8
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone9" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  9
                </div>
              </b-col>
              <b-col>
                <b-form-input v-model="item.scaleValues.stone10" />
              </b-col>
              <b-col class="col-auto">
                <div class="normSum">
                  10
                </div>
              </b-col>
            </b-row>
          </b-card>
        </template>
        <template #item-languages="item">
          <span v-for="content in item.contents" :key="content.countryCode">
            <span :class="'flagItem flag-icon flag-icon-' + content.countryCode"></span>
          </span>
        </template>
        <template #item-selected="item">
          <b-form-checkbox v-model="item.selected" @click="onChangeSelected(item)" />
        </template>
      </EasyDataTable>
      <b-form-group style="margin-top: 2rem;">
        <b-button type="submit" class="me-1" :disabled="submitting">{{ $t('save') }} <i v-if="submitting" class="fa fa-spinner fa-pulse"></i></b-button>
        <b-button variant="danger" type="reset" :disabled="submitting">{{ $t('cancel') }}</b-button>
      </b-form-group>
    </b-col>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['selectedNormGroupId'],
  data() {
    return {
      busyFetching: false,
      submitting: false,
      normGroup: {},
      itemsModified: this.items || []
    }
  },
  computed: {
    ...mapGetters(['selectedCulture']),
    ...mapGetters('scalesModule', ['scales']),
    fields() {
      return [
        { value: 'name', text: this.$t('privatePage.scale') },
        { value: 'languages', text: this.$t('lang') },
        {
          value: 'selected',
          text: this.$t('privatePage.isActive'),
          sortable: true,
          tdClass: 'rightAlignedField',
          thClass: 'rightAlignedField'
        }
      ]
    },
    items() {
      let items = []
      let langCode = this.selectedCulture.langCode

      if (this.scales && this.scales.length > 0) {
        this.scales.forEach(scale => {
          let item = {
            id: scale.id,
            name: '',
            questionFormat: scale.questionFormat,
            contents: [],
            selected: !!(this.getScaleValues(scale).length > 0),
            _showDetails: !!(this.getScaleValues(scale).length > 0),
            scaleValues: this.getScaleValues(scale)[0] || {}
          }
          if (scale.contents) {
            scale.contents.forEach(translation => {
              if (!item.name || translation.langCode === langCode) {
                item.name = translation.name
              }

              item.contents.push({
                languageId: translation.languageId,
                countryCode: translation.countryCode
              })
            })
          }
          items.push(item)
        })
      }
      return items
    },
    submitMessage() {
      return this.$t('save_ok_feedback')
    }
  },
  methods: {
    ...mapActions({
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage'
    }),
    ...mapActions('scalesModule', {
      getAllScales: 'getAllScales'
    }),
    ...mapActions('normGroupsModule', {
      getNormGroup: 'getNormGroup',
      addNormGroup: 'addNormGroup',
      updateNormGroup: 'updateNormGroup'
    }),
    onSubmit(evt) {
      evt.preventDefault()
      this.submitting = true
      let data = {
        name: this.normGroup.name,
        normScaleValues: this.itemsModified
          .filter(item => item.selected)
          .map(activeItem => {
            let {
              stone2,
              stone3,
              stone4,
              stone5,
              stone6,
              stone7,
              stone8,
              stone9,
              stone10
            } = activeItem.scaleValues

            activeItem.scaleValues.stone2 = stone2
              ? parseFloat(stone2.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone3 = stone3
              ? parseFloat(stone3.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone4 = stone4
              ? parseFloat(stone4.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone5 = stone5
              ? parseFloat(stone5.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone6 = stone6
              ? parseFloat(stone6.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone7 = stone7
              ? parseFloat(stone7.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone8 = stone8
              ? parseFloat(stone8.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone9 = stone9
              ? parseFloat(stone9.toString().replace(/,/g, '.'))
              : null
            activeItem.scaleValues.stone10 = stone10
              ? parseFloat(stone10.toString().replace(/,/g, '.'))
              : null
            return { ...activeItem.scaleValues, scaleId: activeItem.id }
          })
      }
      if (this.normGroup.id) {
        data.id = this.normGroup.id
        this.updateNormGroup(data)
          .then(response => {
            this.showSuccessMessage(this.submitMessage)
            this.normGroup = response
            this.submitting = false
          })
          .catch(error => {
            this.showErrorMessage(error)
            this.submitting = false
          })
      } else {
        this.addNormGroup(data)
          .then(response => {
            this.showSuccessMessage(this.submitMessage)
            this.normGroup = response
            this.submitting = false
          })
          .catch(error => {
            this.showErrorMessage(error)
            this.submitting = false
          })
      }
    },
    onReset(evt) {
      evt.preventDefault()
      this.$router.go(-1)
    },
    getScaleValues: function(scale) {
      if (!this.normGroup.id) {
        return []
      }
      const newScaleValues = this.normGroup.normScaleValues.filter(
        scaleValue => scaleValue.scaleId === scale.id
      )
      return newScaleValues
    },
    onChangeSelected: function(scale) {
      const newItems = this.itemsModified.map(i => {
        if (i.id === scale.id) {
          return { ...i, selected: !scale.selected }
        }
        return i
      })
      this.itemsModified = newItems
    }
  },
  created() {
    this.getAllScales()
    if (this.selectedNormGroupId) {
      this.busyFetching = true
      this.getNormGroup(this.selectedNormGroupId).then(response => {
        this.normGroup = response
        this.busyFetching = false
      })
    }
  },
  watch: {
    scales() {
      this.itemsModified = this.items
    },
    normGroup() {
      this.itemsModified = this.items
    }
  }
}
</script>
<style scoped>
.flagItem {
  margin-right: 2px;
}
.normSum {
  padding: 5px 0;
}
.col-auto {
  padding: 0;
}
.normRow {
  padding: 20px 0px 20px 0px;
  margin-right: 2em;
}
.b-table-details {
  margin-bottom: 25px !important;
}
button .fa-spinner {
  margin-left: 5px;
  color: #ffffff;
}
</style>
